<template>
    <div
        v-if="loading"
        data-cy="KCTLoadingIndicator"
        :class="stackClass"
    >
        <FontAwesomeIcon
            class="fa-spin loader"
            icon="spinner"
            size="2x"
        />
        <span data-cy="loadingText">
            <slot name="loading-text" />
        </span>
    </div>
</template>

<script>
    import {library} from '@fortawesome/fontawesome-svg-core';
    import {faSpinner} from '@fortawesome/pro-solid-svg-icons';
    import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';

    library.add(faSpinner);

    /**
     * @group Content
     * A component to display a loading indicator
     */
    export default {
        name: 'KCLoadingIndicator',
        components: {
            FontAwesomeIcon,
        },
        props: {
            /**
             * Used to determine the current loading state
             */
            loading: {
                type: Boolean,
                default: false
            },
            /**
             * Used to determine if the layout should be stacked
             */
            stacked: {
                type: Boolean,
                default: false
            },
        },
        computed: {
            stackClass() {
                return this.stacked ? 'kc-loading column' : 'kc-loading row';
            },
        },
    };
</script>
